// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.snapshot-label {
  --tw-text-opacity: 1;
  color: rgb(50 50 50 / var(--tw-text-opacity));
}

.snapshot-label--disabled {
  --tw-text-opacity: 1;
  color: rgb(140 140 140 / var(--tw-text-opacity));
}

.snapshot-label__date {
  font-weight: 600;
}

.snapshot-label__date--error {
  color: var(--snapshotErrorName);
}

.snapshot-label__name--error {
  color: var(--snapshotErrorDsc);
}

.snapshot-label__value--compact {
  line-height: 1em;
}

.snapshot-label__value--ellipsis {
  width: calc(30.5 * var(--ds-unit));
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/SnapshotLabel/SnapshotLabel.css","webpack://./services/frontend/app/components/SnapshotLabel/SnapshotLabel.css"],"names":[],"mappings":"AADA;ECEE,oBAAoB;EACpB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB","sourcesContent":[".snapshot-label {\n  --tw-text-opacity: 1;\n  color: rgb(50 50 50 / var(--tw-text-opacity));\n}\n\n.snapshot-label--disabled {\n  --tw-text-opacity: 1;\n  color: rgb(140 140 140 / var(--tw-text-opacity));\n}\n\n.snapshot-label__date {\n  font-weight: 600;\n}\n\n.snapshot-label__date--error {\n  color: var(--snapshotErrorName);\n}\n\n.snapshot-label__name--error {\n  color: var(--snapshotErrorDsc);\n}\n\n.snapshot-label__value--compact {\n  line-height: 1em;\n}\n\n.snapshot-label__value--ellipsis {\n  width: calc(30.5 * var(--ds-unit));\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n",".snapshot-label {\n  --tw-text-opacity: 1;\n  color: rgb(50 50 50 / var(--tw-text-opacity));\n}\n\n.snapshot-label--disabled {\n  --tw-text-opacity: 1;\n  color: rgb(140 140 140 / var(--tw-text-opacity));\n}\n\n.snapshot-label__date {\n  font-weight: 600;\n}\n\n.snapshot-label__date--error {\n  color: var(--snapshotErrorName);\n}\n\n.snapshot-label__name--error {\n  color: var(--snapshotErrorDsc);\n}\n\n.snapshot-label__value--compact {\n  line-height: 1em;\n}\n\n.snapshot-label__value--ellipsis {\n  width: calc(30.5 * var(--ds-unit));\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
